import { render, staticRenderFns } from "./MonitoraggioEcgView.vue?vue&type=template&id=18f06b4e"
import script from "./MonitoraggioEcgView.vue?vue&type=script&lang=js"
export * from "./MonitoraggioEcgView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports